module.exports = __webpack_public_path__ + "static/media/vip3.0fcf6662.png";